<template>
  <div class="news">
    <app-header />
    <main>
      <news-list :news-list="newsList" />
    </main>
    <app-footer />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { EventBus } from '../utils/EventBus.js'
  import moment from 'moment'
  import AppHeader from '../components/Header.component'
  import AppFooter from '../components/Footer.component'
  import NewsList from '../components/NewsList.component'

  export default {
    name: 'newsType',
    components: {
      AppHeader,
      AppFooter,
      NewsList
    },
    props: {
      typeId: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        page: 1
      }
    },

    computed: {
      // Map Vuex state.
      ...mapState({
        newsList: state => {
          return state.News.newsListByTypeId.map(news => ({
            ...news,
            images: news.images
              ? JSON.parse(news.images).map(image => encodeURI(image))
              : [],
            published_at: moment(news.published_at).locale('th').fromNow()
          }))
        }
      })
    },

    created () {
      // Listen to scroll to end event.
      EventBus.$on('scroll-to-end', this.appendNewsList)

      return this.$store.dispatch('News/getNewsListByTypeId', {
        typeId: this.typeId,
        page: this.page
      })
    },

    destroyed () {
      EventBus.$off('scroll-to-end', this.appendNewsList)
    },

    methods: {
      appendNewsList () {
        this.page++
        return this.$store.dispatch(`News/getNewsListByTypeId`, {
          typeId: this.typeId,
          page: this.page
        })
      },
      toggleFollow (organizeId) {
        return this.$store.dispatch(`Organize/followOrganization`, organizeId)
          .then(() => this.$store.dispatch(`Organize/getOrganizeDetail`, this.organizationId))
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";

  main {
    // Interpolation for SCSS variables to be in calc
    margin-top: calc(#{$header-height} + 15px);
    padding-bottom: 1px;
    .back-to-top {
      @extend .position-fixed;
      @extend .cursor-pointer;
      right: 20px;
      bottom: 40px;
      img {
        width: 34px;
        height: 34px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/NewsByType.page.vue